var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import Markdown from 'react-markdown';
import BaseComponent from '../base/BaseComponent';
import LinkRenderer from './MarkDownRenderers';
/**
 * Use './MarkDownRenderers' to define custom renderers, in order to override the native tag.
 * See https://github.com/rexxars/react-markdown#node-types
 */
var props = {
    className: 'markdown-container',
    components: {
        p: function (_a) {
            var node = _a.node, rest = __rest(_a, ["node"]);
            return _jsx("span", __assign({}, rest));
        }, // eslint-disable-line
        // @ts-ignore because LinkRenderer is not forched to be of span anymore
        a: function (_a) {
            var node = _a.node, rest = __rest(_a, ["node"]);
            return _jsx(LinkRenderer, __assign({}, rest));
        }, // eslint-disable-line
    },
};
var STYLES = (_jsx("style", { children: "\n    .markdown-container ul {\n      padding-inline-start: 10px;\n    }\n  \n  " }));
// Todo: add key to children
// Request has been added to github: https://github.com/rexxars/react-markdown/issues/249
/**
 * MarkDownComponent
 * Purpose      Renders a string or an array of strings as Paragraph with Markdown styling incl. links.
 * Responsive   None
 * Nestable     False
 * Base         False
 */
var MarkDownComponent = /** @class */ (function (_super) {
    __extends(MarkDownComponent, _super);
    function MarkDownComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Todo: enable backend to return label as array and with string replacent
    MarkDownComponent.prototype.render = function () {
        var _a = this.props, text = _a.text, componentKey = _a.componentKey, styles = _a.styles;
        //TOdo. add index to key
        var markup = Array.isArray(text) ? (text.filter(Boolean).map(function (line, idx) {
            return (_jsx(BaseComponent, { componentKey: componentKey, injectedStyles: styles, htmlTag: "div", children: _jsx(Markdown, __assign({}, props, { children: line })) }, "".concat(componentKey, ".").concat(idx)));
        })) : (_jsx(BaseComponent, { componentKey: componentKey, injectedStyles: styles, htmlTag: "div", children: _jsx(Markdown, __assign({}, props, { children: text })) }));
        return (_jsxs(React.Fragment, { children: [STYLES, markup] }));
    };
    return MarkDownComponent;
}(React.PureComponent));
export default MarkDownComponent;
